import React, { forwardRef } from 'react';
import { withStyles } from '@material-ui/styles';
import cn from 'classnames';
import styles from '../styles';
import { makeStyles } from '@material-ui/core';
import { useFormContext, useWatch } from 'react-hook-form';

const useStyles = makeStyles(styles);

const Checkbox = ({ name, error, label, registration }, ref) => {
  const classes = useStyles();

  // const { field, label, direction, disabledOnEdit, disabled, validate } = i;

  // const isDisabled = disabled || (disabledOnEdit && mode === 'EDIT');

  return (
    <div className={cn(classes.inputContainer)}>
      <div className="row-start-center">
        <input
          type="checkbox"
          // disabled={isDisabled}
          className={cn(
            classes.input,
            classes.checkboxInput,
            // !!error && classes.textInputError,
            // isDisabled && classes.disabledInput,
          )}
          ref={ref}
          {...registration}
        />
        <span style={{ marginLeft: 10 }}>{label}</span>
      </div>
    </div>
  );
};

export default forwardRef(Checkbox);
